import { render, staticRenderFns } from "./VacancyCreateForm.vue?vue&type=template&id=9bdc2470&scoped=true"
import script from "./VacancyCreateForm.vue?vue&type=script&lang=ts"
export * from "./VacancyCreateForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bdc2470",
  null
  
)

export default component.exports